import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type StartETMImportByUploadResponse = {
   jobId: string;
};

export async function startExternalTrainingModuleImportByUpload(
   importId: number,
   file: File,
   common: CommonRequestOptions = {}
): Promise<StartETMImportByUploadResponse> {
   const body = new FormData();

   body.append('externalTrainingModule', file);

   return makeRequest('post', `/external-training-modules/imports/${importId}/start/byUpload`, {
      ...common,
      headers: {
         'Content-Type': 'multipart/form-data',
      },
      body,
   });
}
